import { Tooltip, TooltipContent, TooltipTrigger } from '@/platform/ui';
import { InformationCircleIcon } from '@heroicons/react/20/solid';

/**
 * A focusable info button that explains a term in one sentence.
 */
const InfoTip = ({ label, children }) => (
    <Tooltip>
        <TooltipTrigger asChild>
            <button
                type='button'
                aria-label={label}
                className='focus-visible:outline-primary-600 ml-1 inline-flex rounded-full align-middle text-gray-400 hover:text-gray-600 focus-visible:outline-2 focus-visible:outline-offset-2'
            >
                <InformationCircleIcon aria-hidden='true' className='size-4' />
            </button>
        </TooltipTrigger>
        <TooltipContent>{children}</TooltipContent>
    </Tooltip>
);

export default InfoTip;
